import { connect } from "react-redux";
import { useState } from "react";
import { State } from "redux/store";

import { getShowRequestDemoModal } from "redux/Modals/selectors";
import { getUserInfo } from "redux/User/selectors";

import RequestDemoModal from "views/modals/RequestDemoModal";
import ResourceConfigurationBar from "./ResourceConfigurationBar";
import AnnotationStep from "./Annotations";
import IndexTypeStep from "./IndexType";
import IndexingStep from "./Indexing";
import ConnectStep from "./Connect";
import UploadStep from "./Upload";
import { useIndexTypeStatus } from "./useIndexTypeStatus";

import { ContactUsComponentType, SetStateFunction } from "types";
import { MODEL_PACK } from "helpers/constants/indexTypes";

import styles from "./style.module.scss";

const StepsSection = ({
  showStartBanner,
  setShowStartBanner,
  showRequestDemoModal,
  userInfo,
  modelPack,
}: StepsSectionProps) => {
  const [indexType, setIndexType] = useState<string>(
    modelPack || MODEL_PACK.VL_LARGE,
  );
  const { indexTypeStatus, markIndexTypeComplete } = useIndexTypeStatus();

  return (
    <div className={styles.stepsSection}>
      <ConnectStep
        showStartBanner={showStartBanner}
        setShowStartBanner={setShowStartBanner}
        isInternalUser={userInfo?.isInternalUser !== false}
      />

      <AnnotationStep />
      <IndexTypeStep
        indexType={indexType}
        setIndexType={setIndexType}
        indexTypeStatus={indexTypeStatus}
        markIndexTypeComplete={markIndexTypeComplete}
      />
      <UploadStep indexType={indexType} indexTypeStatus={indexTypeStatus} />
      <div className={styles.separator}></div>
      <IndexingStep />

      {/* Resource Configuration - Below Visual Layer Indexing (Internal Users Only) */}
      {userInfo?.isInternalUser && <ResourceConfigurationBar />}

      {showRequestDemoModal.flag && (
        <RequestDemoModal calledFrom={showRequestDemoModal.calledFrom} />
      )}
      <div className={styles.hiddenText}>hiddenText</div>
    </div>
  );
};

const mapStateToProps = (state: State) => {
  return {
    showRequestDemoModal: getShowRequestDemoModal(state),
    userInfo: getUserInfo(state),
  };
};

export default connect(mapStateToProps)(StepsSection);

interface StepsSectionProps {
  showStartBanner: boolean;
  showRequestDemoModal: { flag: boolean; calledFrom: ContactUsComponentType };
  setShowStartBanner: SetStateFunction<boolean>;
  userInfo?: { isInternalUser: boolean; email: string };
  modelPack?: string | null;
}
